import React from 'react'
import classNames from 'classnames'
import CarouselNav from '@/atoms/CarouselNav'
import useCarousel from '@/utils/useCarousel'
import SectionHeading from './SectionHeading'

interface Props {
  children: React.ReactNode | React.ReactNode[]
  className?: string
  itemsCount: number
  layout: 'fixed' | 'responsive'
  subtitle: string
  title: string
}

const Section: React.FC<Props> = ({ children, className, itemsCount, layout, subtitle, title }) => {
  const [scrollerRef, { canScrollBack, canScrollForward, scrollBack, scrollForward }] = useCarousel<HTMLDivElement>()

  return (
    <div className={classNames('relative', className)}>
      <SectionHeading title={title} subtitle={subtitle} />

      <div
        ref={scrollerRef}
        className={classNames(
          'relative flex flex-col snap-x snap-mandatory gap-6 overflow-scroll scrollbar-none sm:flex-row',
          {
            'sm:mx-6 md:mx-8 lg:mx-12 2xl:mx-[4.5rem]': layout === 'responsive',
            'md:grid md:grid-cols-[repeat(2,_minmax(408px,_1fr))]': itemsCount === 2,
          },
        )}
      >
        {children}
      </div>
      <CarouselNav
        onClick={scrollBack}
        active={canScrollBack}
        orientation="horizontal"
        direction="back"
        className={classNames('ml-2', { 'opacity-75 hover:opacity-100': canScrollBack })}
        theme="dark"
      />
      <CarouselNav
        onClick={scrollForward}
        active={canScrollForward}
        orientation="horizontal"
        direction="forward"
        className={classNames('mr-2', { 'opacity-75 hover:opacity-100': canScrollForward })}
        theme="dark"
      />
    </div>
  )
}

export default Section
